exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.b-form-group.required .col-form-label:after {\n  content:\"*\";\n  color:red;\n}\n.table.b-table>thead>tr>th {\n  background-color: white;\n  position: sticky;\n  position: -webkit-sticky;\n  top: 0;\n  z-index: 2;\n}\n.main .container-fluid  {\n  padding: 0 20px 0 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":false,"sourceMap":false,"alias":{"../img":"../static/img"}}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-c6c6ec7a","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/containers/Full.vue
// module id = 933
// module chunks = 2